import type { WSMessage } from './types';

type PresenceMessage = Extract<WSMessage, { type: 'ft3d_player_presence' }>;

export function handleFt3dPlayerPresence(message: PresenceMessage): void {
    const currentCampaignId = String(window.FateTide?.campaign?.id ?? '').trim().toUpperCase();
    if (!currentCampaignId || String(message.campaign_id ?? '').trim().toUpperCase() !== currentCampaignId) return;
    window.dispatchEvent(new CustomEvent<PresenceMessage>('ft3d-player-presence-message', {
        detail: message,
    }));
}

window.handleFt3dPlayerPresence = handleFt3dPlayerPresence;
